/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { Store } from '@ngrx/store';
import { selectUserDataForPendo } from '../../user/+state/user.selectors';
import { filter, map, take } from 'rxjs/operators';
import { NGX_PENDO_CONTEXT } from 'ngx-pendo';

@Injectable({
    providedIn: 'root'
})
export class PendoService {
    private pendo = inject(NGX_PENDO_CONTEXT);

    constructor(private env: EnvironmentService, private store: Store) {
        if (this.pendo) {
            this.initialize();
        }
    }

    private initialize() {
        this.store.select(selectUserDataForPendo).pipe(
            filter((data) => !!data),
            take(1),
            map((data) => this.getPendoBaseParams(data))
        ).subscribe(async (params) => {
            this.pendo.updateOptions(params);
            this.pendo.initialize({
                dataHost: 'https://data.activity.commandcentral.com',
                contentHost: 'https://content.activity.commandcentral.com',
                visitor: params.visitor,
                account: params.account
            });
        });
    }

    private getPendoBaseParams({account, visitor}) {
        const environmentName = this.env.environment.ENVIRONMENT ? this.env.environment.ENVIRONMENT.replace('apollo-', '') : 'development';
        return {
            visitor: {
                application: 'VESTA NXT',
                environment: environmentName,
                ...visitor,
            },
            account: {
                application: 'VESTA NXT',
                environment: environmentName,
                ...account,
            }
        };
    }
}
